import styles from "./index.module.scss";
import useLogin from "@/hooks/useLogin";
import React, {useEffect, useMemo, useState} from "react";
import ConnectTikTipsModal from "@/components/connectTikTipsModal";
import {
  APIAddFavoriteItems, APIAddKiteChen,
  APICapInvitation,
  APIDeleteFavoriteItems,
  APIGetLinkByPid,
  APIRefreshCapStatus
} from "@/api";
import {isMobile} from "@/utils/action";
import {message} from "antd";
import AddShowCaseStepModal from "@/components/ProductModal";
import {LoadingOutlined} from "@ant-design/icons";
import {LikeIcon, NoLikeIcon} from "@/config/config";
import LoginModal from "@/components/LoginModal";
import {getProductImage, getProductImageV2} from "@/utils/utils";
import gaTracker from "@/ga";
import {useRouter} from "next/router";
import Image from "next/image";
import UnLockHighestCommissionModal from "@/components/UnLockHighestCommissionModal";
import {GetFreeSampleModal} from "@/components/GetFreeSampleModal";
import {useSelector} from "react-redux";
import AppImage from "@/components/AppImage";
import useLanguage from "@/hooks/useLanguage";


export const ProductTag = ({className, text}) =>{
  return <div className={`h-[18px] text-[11px]  px-[10px] rounded-tl-[20px] rounded-r-[20px] flex items-center justify-center ${className}`}>
    {text}
  </div>;
};

const ProductCard = ({item, fromCollection, selected, onSelect, saleId}) =>{
  const { needLogin } = useLogin();
  const [showConnectTips, setShowConnectTips] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showCase, setShowCase] = useState(false);
  const [freeSampleModal, setFreeSampleModal] = useState(false);
  const [getFreeSampleModal, setGetFreeSampleModal] = useState(false);
  const [productLink, setProductLink] = useState("");
  const [collected, setCollected] = useState(item.collect);
  const [isObtain, setIsObtain] = useState(false);
  const userInfo = useSelector(state => state.home.userInfo.userInfo);
  const router = useRouter();
  const [freeSampleType, setFreeSampleType] = useState(1);
  const {t, isUS} = useLanguage();
  useEffect(()=>{
    setIsObtain(userInfo?.obtain);
  }, [userInfo]);

  const toDetails = () =>{
    if (router.pathname === "/"){
      gaTracker.trackEvent("home_product_card", true);
    }
    if (router.pathname === "/product/[id]"){
      gaTracker.trackEvent("details_product_card", true);
    }
    if (router.pathname === "/person-center"){
      gaTracker.trackEvent("collection_product_card", true);
    }

    if (router.pathname === "/hotsale/[id]"){
      gaTracker.trackEvent("pop_product_card", true);
    }

    const query = saleId ? `?saleId=${saleId}` : "";

    window.open(`/product/${item.productId}${query}`, '_blank');
  };

  const addTk = (e) =>{
    e.stopPropagation();
    if (router.pathname === "/"){
      gaTracker.trackEvent("home_add_showcase", true);
    }
    if (router.pathname === "/product/[id]"){
      gaTracker.trackEvent("details_rec", true);
    }
    if (router.pathname === "/person-center"){
      gaTracker.trackEvent("collection_add_showcase", true);
    }
    if (router.pathname === "/hotsale/[id]"){
      gaTracker.trackEvent("pop_add_showcase", true);
      APIAddKiteChen({ sectionId: saleId ?? "1", productId: item.productId.toString() }).then().catch();
    }
    if (needLogin && (!saleId || isUS)) {
      setShowConnectTips(true);
      return;
    }
    if (loading) return;
    if (item.needApplyLink) {
      setLoading(true);
      APIGetLinkByPid(item.productId).then(resp => {
        if (resp?.data.url) {
          const url = resp.data.url;
          setProductLink(url);
          setShowCase(true);
        } else {
          message.info(t('product.taken_down'));
        }
      }).finally(() => {
        setLoading(false);
      });
    } else {
      const url = item.url;
      setProductLink(url);
      setShowCase(true);
    }
  };

  const addCollect = () => {

    if (router.pathname === "/"){
      gaTracker.trackEvent("home_collect", true);
    }
    if (router.pathname === "/product/[id]"){
      gaTracker.trackEvent("details_collect", true);
    }
    if (router.pathname === "/hotsale/[id]"){
      gaTracker.trackEvent("pop_collect", true);
    }

    let user = localStorage.getItem("user");
    if (user) {
      user = JSON.parse(user);
      APIAddFavoriteItems({
        uid: user.id,
        itemId: item.productId
      }).then(resp => {
        if (resp) {
          console.log("收藏成功");
        }
      });
    }
  };

  const removeCollect = () => {
    if (router.pathname === "/"){
      gaTracker.trackEvent("home_remove_collect", true);
    }
    if (router.pathname === "/product/[id]"){
      gaTracker.trackEvent("details_remove_collect", true);
    }

    if (router.pathname === "/hotsale/[id]"){
      gaTracker.trackEvent("pop_remove_collect", true);
    }
    let user = localStorage.getItem("user");
    if (user) {
      user = JSON.parse(user);
      APIDeleteFavoriteItems({
        uid: user.id,
        itemId: item.productId
      }).then(resp => {
        if (resp) {
          console.log("取消收藏成功");
        }
      });
    }
  };

  const collect = (e) => {
    e.stopPropagation();
    if (needLogin) {
      setShowConnectTips(true);
      return;
    }
    if (!collected) {
      addCollect();
      setCollected(true);
    } else {
      removeCollect();
      setCollected(false);
    }
  };

  const renderEarnWarp = useMemo(() =>{
    if (!isObtain){
      return       <div className={"flex items-center mt-3 justify-between"}>
        <div className={"w-[80px] h-[20px] rounded-[18px] bg-[#F3F4F6] flex items-center justify-center"}>
          <div className={"text-sm font-700 text-color2"}>{`${item.finishRate}%`}</div>
          <Image width={12} height={12} className={"w-4 h-3 ml-1"} src={"/images/anystarr-commission.svg"} alt={""}></Image>
        </div>
        <Image className={"w-4"} src={"/images/home-card-right-icon.svg"} alt={""} width={11} height={8}></Image>
        <div onClick={(e)=>{
          e.stopPropagation();
          if (router.pathname === "/"){
            gaTracker.trackEvent("home_cap_comm");
          }
          if (router.pathname === "/person-center"){
            gaTracker.trackEvent("collection_cap_comm");
          }
          if (router.pathname === "/product/[id]"){
            gaTracker.trackEvent("details_rec_cap_comm");
          }
          if (router.pathname === "/hotsale/[id]"){
            gaTracker.trackEvent("pop_cap_comm");
          }
          if (needLogin) {
            setShowConnectTips(true);
            return;
          }
          setFreeSampleType(1);
          setFreeSampleModal(true);
        }} className={"w-[80px] h-[20px] rounded-[18px] bg-[#FFEEEE] flex items-center justify-center"}>
          <div className={"text-sm font-700 text-color2"}>{`${item.capRate}%`}</div>
          <Image width={12} height={12} className={"w-3 h-3 ml-1"} src={"/images/offical-commission.svg"} alt={""}></Image>
        </div>
      </div>;
    }
    return <div className={"flex items-center mt-3 justify-between"}>
      <div className={"w-[80px] h-[20px] rounded-[18px] bg-[#F3F4F6] flex items-center justify-center"}>
        <div className={"text-sm font-700 text-color2"}>{`${item.finishRate}%`}</div>
      </div>
      <Image className={"w-4"} src={"/images/home-card-right-icon.svg"} alt={""} width={11} height={8}></Image>
      <div className={"w-[80px] h-[20px] rounded-[18px] bg-[#F3F4F6] flex items-center justify-center"}>
        <div className={"text-sm font-700 text-color2 font-bold"}>{`${item.capRate}%`}</div>
        <Image width={12} height={12} className={"w-4 h-3 ml-1"} src={"/images/anystarr-commission.svg"} alt={""}></Image>
      </div>
    </div>;
  }, [isObtain, needLogin]);

  const renderEarnPer = useMemo(() =>{
    if (!isObtain) {
      return <div className={styles.card_price}><span>{`${item?.showEarnPer ?? "--"}`}</span></div>;
    }
    return <div className={styles.card_price}><span>{`${item?.showCapEarnPer ?? "--"}`}</span></div>;
  }, [isObtain]);

  const getImage = () => {

  };

  return <div>
    <div onClick={toDetails} className={styles.product_card}>
      <div className={styles.top_content}>
        <img src={ getProductImageV2(item)} className={styles.card_img} />
        <div className={"h-[49px] px-3 py-1 absolute bottom-0 bg-[#0D132CE5] w-full rounded-tl-[20px]"}>
          <div className={"text-sm text-white text-line-1"}>{item.title ?? "--"}</div>
          <div className={"text-sm text-white mt-1"}><span>{item.showPrice}</span></div>
        </div>
        <div className={"absolute top-0 py-2 left-0 w-[calc(100% - 48px)] px-2.5 flex flex-wrap gap-2"}>
          {
            fromCollection && <div onClick={(e)=>{
              e.stopPropagation();
              onSelect([item.productId]);
            }}>
              {
                selected ? <AppImage  src={"/images/product/checked-icon.svg"}></AppImage> :
                  <AppImage src={"/images/product/no-check-icon.svg"}></AppImage>
              }
            </div>
          }
          {
            item.productTag2 === 1 && <ProductTag className={"bg-[#F8F0EDF0] text-[#FF6C4F]"} text={t('product.tag.top_selling')}></ProductTag>
          }
          {
            item.productTag3 === 1 && <ProductTag className={"bg-[#F8EDF7F0] text-[#E04DB1]"} text={t('product.tag.trending')}></ProductTag>
          }
          {
            item.productTag1 === 1 && <ProductTag className={"bg-[#E8F1EFF0] text-[#1EC29A]"} text={t('product.tag.free_sample')}></ProductTag>
          }
        </div>
        <div className={"absolute top-0 right-0"}>
          <div className={"relative"}>
            <Image className={"w-[48px] h-[48px]"} src={"/images/product/rectangle-icon.svg"} alt={""} width={20} height={20}></Image>
            <Image onClick={collect} className={"absolute right-[2px] top-[2px] m-auto w-6 h-6"} src={`/images/product/${ collected ? "collected-icon.svg" : "collect-icon.svg" }`} alt={""} width={24} height={24}></Image>
          </div>
        </div>
      </div>
      <div className={styles.bottom_content}>
        <div className={"flex flex-col"}>
          {renderEarnPer}
          <div className={styles.card_earn_sale}>{t("home.filter.earn_per_sale")}</div>
        </div>
        {renderEarnWarp}
        <div className={"flex items-center mt-2 justify-between"}>
          <div className={"w-[85px] text-center text-[11px] text-[#B3B6C1]"}>{t('product.earnings')}</div>
          <div className={"w-[85px] text-center text-[11px] text-[#B3B6C1]"}>{t('product.max_earnings')}</div>
        </div>
        <div className={"mt-3 flex items-center justify-between gap-4"}>
          <div onClick={(e)=>{
            e.stopPropagation();
            if (needLogin) {
              setShowConnectTips(true);
              return;
            }
            if (router.pathname === "/"){
              gaTracker.trackEvent("home_sample");
            }
            if (router.pathname === "/person-center"){
              gaTracker.trackEvent("collection_sample");
            }
            if (router.pathname === "/product/[id]"){
              gaTracker.trackEvent("details_rec_sample");
            }
            if (router.pathname === "/hotsale/[id]"){
              gaTracker.trackEvent("pop_sample");
            }

            setGetFreeSampleModal(true);
          }} className={"h-[28px] bg-[#FDEFE9] flex items-center justify-center w-full rounded-[6px]"}>
            <Image width={16} height={16} className={"w-4 h-4 mr-1"} src={"/images/free-sample.svg"} alt={""}></Image>
            <div className={"text-primary text-sm"}>{t('product.sample')}</div>
          </div>
          <div onClick={addTk} className={"h-[28px] hover:opacity-80 trans-all text-white flex items-center bg-linear justify-center w-full rounded-[6px]"}>
            { loading ? <LoadingOutlined/> : <Image width={16} height={16} className={"w-4 h-4 mr-1"} src={"/images/add-showcase.svg"} alt={""}></Image> }
            <div className={"text-white text-sm"}>{t('product.add')}</div>
          </div>
        </div>
      </div>
    </div>
    {
      showConnectTips &&  <LoginModal open={showConnectTips} mobile={false} onCancel={() => setShowConnectTips(false)}></LoginModal>
      // showConnectTips && <ConnectTikTipsModal show={showConnectTips} onCancel={() => setShowConnectTips(false)}></ConnectTikTipsModal>
    }
    {
      showCase && <AddShowCaseStepModal productIds={item.productId} visible={showCase} link={productLink} onCancel={() => setShowCase(false)} />
    }
    {
      freeSampleModal && <UnLockHighestCommissionModal utmObtain={"highest_comm_obtain"} onSuccess={()=>{
        setFreeSampleModal(false);
      }} type={freeSampleType} title={item.title} imgUrl={getProductImage(item)} show={freeSampleModal} onCancel={()=>setFreeSampleModal(false)}></UnLockHighestCommissionModal>
    }
    {
      getFreeSampleModal && <GetFreeSampleModal productItem={item} title={item.title} imgUrl={getProductImage(item)} show={getFreeSampleModal} onCancel={()=>setGetFreeSampleModal(false)}></GetFreeSampleModal>
    }
  </div>;
};
export default ProductCard;

